import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import GetAppIcon from '@mui/icons-material/GetApp';

import UserService from "services/UserService";
import axios from "axios";
import { getMBMCampaigns } from "services/ConfigServices";
import { campaigntext } from "variables/MBM/campaign";
import { definitionData, eosprotocoleData } from "variables/MBM/lists/iotdevices";
import moment from "moment";

import { downloadCSV } from "utilities/exporttabletocsv";
import Button from "components/CustomButtons/Button.js";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";
import AddCampaign from "./AddCampaign";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

export default function useCampaignsTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbm_campaigns_admin = permis.includes("mbm_campaigns_admin");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const url = getMBMCampaigns(chartIdGroup);
  const [results, setResults] = useState({ meters: [] });
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [campaignsdata, setCampaignsData] = useState([]);
  const [campaigns, setCampaigns] = useState([]);

  const refreshTable = () => {
    setRefresh(!refresh);
  }

  //Ok but should not be able to change group at this level
  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === chartIdGroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      //setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          url,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        setResults(response.data);
        setCampaignsData(response.data.iotdevices);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
      fetchData();
    }
  }, [chartIdGroup, refresh]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px", marginRight: "10px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItems = _.get(results, `campaigns`, []).filter(
    (item) =>
      (item.parameters?.general?.name && item.parameters.general.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters?.general?.groups && groupInfoListById["" + item.parameters.general.groups] && groupInfoListById["" + item.parameters.general.groups].toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = campaigns.map((item) => {
      let mbmcampaigntoexport = {};
      mbmcampaigntoexport[campaigntext.id] = item.id;
      mbmcampaigntoexport[campaigntext.name] = item.name;
      mbmcampaigntoexport[campaigntext.group] = groupInfoListById["" + item.groupid];
      return mbmcampaigntoexport;
    });
    return (
      <>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {mbm_campaigns_admin && (
          <>
            <UploadButton type="button" onClick={handleClear}>
               <AddCampaign refetch={refreshTable} onClick={handleClear} /> 
            </UploadButton>
            <UploadButton type="button" onClick={handleClear}>
              {/* <EditMeters refetch={refreshTable} onClick={handleClear} marketmeters={marketmeters} disabled={!marketmeters || marketmeters.length < 1} /> */}
            </UploadButton>
            <UploadButton type="button" onClick={handleClear}>
              {/* <DeleteMeters refetch={refreshTable} onClick={handleClear} marketmeters={marketmeters} disabled={!marketmeters || marketmeters.length < 1} /> */}
            </UploadButton>
          </>
        )}
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!campaigns || campaigns.length < 1} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, campaignsdata, campaigns]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refetch: refreshTable,
    setCampaigns
  };
}
